export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 2:
      if (splitKey[0].length === 1 || splitKey[0] === 'SP') return ['RED', 'BLUE', 'GREEN'].includes(splitKey[1]) ? splitKey[1].toLowerCase() : splitKey[1]
      if (splitKey[0] === 'COMBINATION') return Number(splitKey[1]) < 10 ? `${0}${splitKey[1]}` : splitKey[1]
      if (splitKey[0] === 'ALL') {
        if (splitKey[1] === 'ODD') return 'oddnum'
        if (splitKey[1] === 'EVEN') return 'evennum'
        else return splitKey[1]
      }
      return betKey

    case splitKey.length === 3:
      if (splitKey[0].length === 1 && !['LOCATE', 'MATCH', 'PASS'].includes(splitKey[1])) return `${splitKey[1]}:${splitKey[2]}`
      if (splitKey[0] === 'ALL' && splitKey[1] !== 'TAIL') return splitKey[2]
      if (splitKey[0] === 'SP' && splitKey[1] !== 'PASS') return (splitKey[1] === 'OVER' || splitKey[1] === 'UNDER') ? betKey : `${splitKey[1]}:${splitKey[2]}`
      if (splitKey[0] === 'CHOOSE') return `${splitKey[1].toLowerCase()}Ball${splitKey[2]}`
      if (splitKey[0] === 'COMBINATION') {
        return Number(splitKey[2]) < 10
          ? `00${splitKey[2]}`
          : Number(splitKey[2]) < 100
            ? `0${splitKey[2]}`
            : splitKey[2]
      }
      if (splitKey[1] === 'PASS') return ['RED', 'BLUE', 'GREEN'].includes(splitKey[2]) ? splitKey[2].toLowerCase() : splitKey[2]
      if (splitKey[1] === 'ZODIAC') return `${splitKey[1]}:${splitKey[2]}`
      if (splitKey[1] === 'TAIL') {
        if (splitKey[2].length === 1) return `${splitKey[1]}:${splitKey[2]}`
        else return splitKey[0] === 'SP' ? betKey : `${splitKey[1]}:${splitKey[2]}`
      }
      if (['LOCATE', 'MATCH'].includes(splitKey[1])) return Number(splitKey[0]) < 10 ? `${0}${splitKey[0]}` : splitKey[0]
      return betKey

    case splitKey.length === 4:
      if (splitKey[0].length === 1 && splitKey[1] !== 'DIGIT') return `${splitKey[1]}:${splitKey[2]}:${splitKey[3]}`
      if (splitKey[0] === 'SP') return splitKey[1] === 'DIGIT' ? `${splitKey[2]}:${splitKey[3]}` : `${splitKey[1]}:${splitKey[2]}:${splitKey[3]}`
      if (splitKey[0] === 'CHOOSE') return `chose${splitKey[1]}${splitKey[3]}`
      if (splitKey[0] === 'ALL') {
        if (splitKey[3] === 'NL') return splitKey[2]
        if (splitKey[1] === 'ZODIAC' && splitKey[2] === 'EXCLUDE') return splitKey[3]
        if (splitKey[1] === 'TAIL') return `TAIL:${splitKey[2]}`
      }
      if (splitKey[1] === 'DIGIT') return `${splitKey[2]}:${splitKey[3]}`
      if (splitKey[2] === 'ZODIAC') return splitKey[3].length === 1 ? `${splitKey[2]}:${splitKey[3]}` : `${splitKey[0]}:${splitKey[2]}:${splitKey[3]}`

      return betKey

    case splitKey.length === 5:
      if (splitKey[0] === 'SP') return splitKey[4]
      if (splitKey[0] === 'NL') return `sky${Number(splitKey[1]) + 1}`
      if (splitKey[0] === 'CHOOSE') {
        return `star${splitKey[1]}`
      }
      return betKey

    case splitKey.length === 6:
      if (splitKey[0] === 'CHOOSE') return `spPass${splitKey[1]}`
      if (splitKey[0] === 'MIX') {
        if (betKey === 'MIX:CHOOSE:3:MATCH:2:NL') return 'get3in2'
        if (betKey === 'MIX:CHOOSE:3:MATCH:3:NL') return 'get3'
        if (betKey === 'MIX:CHOOSE:2:MATCH:2:NL') return 'get2'
      }
      return betKey

    case splitKey.length === 7:
      if (betKey.includes('ZODIAC')) return `ZODIAC:${splitKey[6]}`
      if (betKey.includes('TAIL')) return `TAIL:${splitKey[6]}`
      if (splitKey[0] === 'MIX') {
        if (betKey === 'MIX:CHOOSE:2:MATCH:1:NL:SP') return 'get2Sp'
      }
      return betKey

    default:
      return betKey
  }
}
